<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconjigou1"></i>
      学生管理
    </div>
    <div class="padding-sm">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未报道" name="2"></el-tab-pane>
        <el-tab-pane label="实习中" name="3"></el-tab-pane>
        <el-tab-pane label="实习结束" name="4"></el-tab-pane>
      </el-tabs>
      <div class="flex align-center margin-bottom-xs">
        <div class="flex align-center">
          <el-select v-model="gangwei" placeholder="请选择实习岗位" class="margin-right-sm" style="width: 100%">
            <el-option
                v-for="item in gangweiLiset"
                :key="item.sx_id"
                :label="item.sx_name"
                :value="item.sx_id">
            </el-option>
          </el-select>
          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
      </div>


      <el-table
          :data="volunteerList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >
        <el-table-column label="学生姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_name }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="所在院校">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.org_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_sex === 1?'男':'女' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_idcard }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="实习开始日期">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.qian_time }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="实习结束日期">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.finish_time }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="medium"
                  type="primary"
                  @click="showItem(scope.row.stu_id)"
              >查看详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <stu-dialog :subdialogDialog="dialog" :setId="setId" @cancelDialog="cancelDialog"/>
  </div>
</template>

<script>
import {xieStationList,xietiao5Student} from "@/api/coordinate";
import stuDialog from "@/views/coordinate/page/dialog/stuDialog";
export default {
  name: "trainee",
  data() {
    return {
      activeName: '2',
      gangweiLiset:[],
      gangwei:'',
      stu_name: '',
      page:1,
      limit:10,
      total:0,
      volunteerList: [],
      multipleSelection: [],
      setId: 0,
      dialog: false,
    };
  },
  components: {stuDialog},
  created() {
    this.$emit(
        "setIndex",
        '/coordinate/practice3',
        "当前位置：实习基地数据 > 学生管理",
        true
    );
    this.init()
  },
  methods: {
    async init() {
      let _list = await xieStationList(this.$route.query.id, '')
      this.gangweiLiset = _list.data
      this.gangwei = _list.data[0].sx_id
      this.getList()
    },
    async getList() {
      let _list = await xietiao5Student(this.stu_name,this.activeName,this.gangwei,this.page,this.limit)
      this.volunteerList = _list.data.list
      this.total = _list.data.count
    },
    onSearch() {
      this.getList()
    },
    handleClick(tab) {
      this.getList()
    },
    showItem(id) {
      this.setId = id
      this.dialog = true
    },
    cancelDialog() {
      this.setId = 0
      this.dialog = false
    },
  }
}
</script>

<style scoped lang="scss">

</style>